var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M5.3335 24.0001V6.66675C5.3335 4.45741 7.12416 2.66675 9.3335 2.66675H18.6668L26.6668 10.6667V24.0001C26.6668 26.2094 24.8762 28.0001 22.6668 28.0001H9.3335C7.12416 28.0001 5.3335 26.2094 5.3335 24.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 8.00008V2.66675L26.6665 10.6667H21.3332C19.8598 10.6667 18.6665 9.47341 18.6665 8.00008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 22.6667H10.6668C9.93083 22.6667 9.3335 22.0693 9.3335 21.3333C9.3335 20.5973 9.93083 20 10.6668 20H16.0002C16.7362 20 17.3335 20.5973 17.3335 21.3333C17.3335 22.0693 16.7362 22.6667 16.0002 22.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 17.3334H10.6668C9.93083 17.3334 9.3335 16.7361 9.3335 16.0001C9.3335 15.2641 9.93083 14.6667 10.6668 14.6667H21.3335C22.0695 14.6667 22.6668 15.2641 22.6668 16.0001C22.6668 16.7361 22.0695 17.3334 21.3335 17.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.d6aa9b1d8ad94a774f54c069cc7a0afb.svg";
export { ForwardRef as ReactComponent };